const CHUNK_ERR_RE = /dynamically imported module|chunk/i;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERR_RE.test(error.message);
}
